module.exports = __webpack_public_path__ + "static/media/marching-host.15edeb29.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/marching-host.pdf
// module id = 193
// module chunks = 0